import { t } from '../i18n.ts'
import type { Vote } from '../store/types.ts'
import { ThumbDownIcon, ThumbUpIcon } from './ConcertRow.tsx'
import './ThumbControls.css'

/**
 * Three-state rating: up, down, or neither. Tapping the active option clears it.
 *
 * Exposed as a radio group rather than two toggle buttons — the options are
 * mutually exclusive, which is what a radio group means, and it gives screen
 * readers the "1 of 2" relationship for free.
 */
export function ThumbControls({
  vote,
  onChange,
}: {
  vote: Vote
  onChange: (vote: Vote) => void
}) {
  function pick(next: Exclude<Vote, null>) {
    onChange(vote === next ? null : next)
  }

  return (
    <div className="thumbs" role="radiogroup" aria-label={t.concert.ratingLabel}>
      <button
        type="button"
        role="radio"
        aria-checked={vote === 'up'}
        className="thumbs__button thumbs__button--up"
        data-active={vote === 'up' || undefined}
        onClick={() => pick('up')}
      >
        <ThumbUpIcon />
        <span>{t.concert.thumbsUp}</span>
      </button>

      <button
        type="button"
        role="radio"
        aria-checked={vote === 'down'}
        className="thumbs__button thumbs__button--down"
        data-active={vote === 'down' || undefined}
        onClick={() => pick('down')}
      >
        <ThumbDownIcon />
        <span>{t.concert.thumbsDown}</span>
      </button>
    </div>
  )
}
